import { render, staticRenderFns } from "./ViewVideoPlayer.vue?vue&type=template&id=c8054336"
import script from "./ViewVideoPlayer.vue?vue&type=script&lang=js"
export * from "./ViewVideoPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports